import React, { useState, Fragment, useEffect } from 'react';
import { Tooltip } from 'reactstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
  Row,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CustomInput,
} from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
  postAPI_Create_QuickReply,
  gAPI_QuestionSets,
  gAPI_QuickReply_ById,
  putAPI_Update_QuickReply,
  gAPI_QuickReplyDelete_ById,
} from '../../../../../constants/APIs';
import Validation from '../../../../../components/Validation';
export function AddNewReply({
  id,
  visible,
  toggleModal,
  formLabel,
  propertyId,
  domains,
  LoadData,
}) {
  const [assistantList, setAssistantList] = useState('');
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [quickReplyData, setQuickReplyData] = useState({
    groupId: getGroupID(),
    name: [
      {
        statement: '',
        languageCode: 'en',
      },
    ],
    message: [
      {
        statement: '',
        languageCode: 'en',
      },
    ],
    dynamicTemplate: '',
    templateType: 'Static',
    templateWidget: 'ComingSoon',
    templateChannel: 'Chat',
    creator: 'dashboard',
  });

  useEffect(() => {
    loadResponse();
    if (id !== undefined) {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_QuickReply_ById}/${id}`,
      })
        .then((res) => {
          setQuickReplyData(res.data);
        })
        .catch((err) => console.log('err', err));
    } else {
      setQuickReplyData({
        ...quickReplyData,
        name: [
          {
            statement: '',
            languageCode: 'en',
          },
        ],
        message: [
          {
            statement: '',
            languageCode: 'en',
          },
        ],
      });
    }
  }, [id, visible]);

  const handleChangeArr = (e) => {
    const key = e.target.name;
    const value = e.target.value;
    setQuickReplyData({
      ...quickReplyData,
      [key]: [
        {
          statement: value,
          languageCode: 'en',
        },
      ],
    });
  };

  const handleDynamicTemplate = (e) => {
    setQuickReplyData({ ...quickReplyData, dynamicTemplate: e.target.value });
  };

  const handleDelete = () => {
    AxiosAPI({
      method: 'put',
      url: `${gAPI_QuickReplyDelete_ById}/${id}`,
      data: {
        deleter: 'dashboard',
      },
    })
      .then((res) => {
        if (
          res.data.HttpStatusCode !== undefined &&
          res.data.HttpStatusCode === 400 &&
          res.data.Messages !== undefined &&
          res.data.Messages !== null &&
          res.data.Messages.length > 0
        ) {
          setMsg(res.data.Messages);
          setOpen(true);
        } else {
          LoadData();
          toggleModal();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };
  const generateDeleteButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This template will be deleted permanently!
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    outline
                    onClick={() => handleDelete()}
                    size="xs"
                  >
                    Delete
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    Cancel
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const loadResponse = async () => {
    return await AxiosAPI({
      methed: 'get',
      url: `${gAPI_QuestionSets}/?propertyId=${propertyId}&groupId=${getGroupID()}&lang=${'en'}`,
    })
      .then((res) => {
        var setslist = res.data.sets.sort(
          (a, b) => a.displayOrder - b.displayOrder
        );
        var list = [];
        if (setslist !== null && setslist.length > 0) {
          setslist
            .filter(
              (l) =>
                l.type === 'DynamicConversationFlow' &&
                l.openAiAssistantId !== ''
            )
            .map((l) => {
              list.push({ id: l.openAiAssistantId, name: l.name });
            });
        }

        setAssistantList(list);
      })
      .catch((err) => {
        console.error(
          'API error:',
          err.response ? err.response.data : err.message
        );
      });
  };

  const handleSubmit = () => {
    if (id !== undefined) {
      const formmatedData = {
        ...quickReplyData,
        Updater: 'admin',
      };

      console.log(formmatedData);

      AxiosAPI({
        method: 'put',
        url: `${putAPI_Update_QuickReply}/${id}`,
        data: formmatedData,
      })
        .then((res) => {
          if (
            res.data.HttpStatusCode !== undefined &&
            res.data.HttpStatusCode === 400 &&
            res.data.Messages !== undefined &&
            res.data.Messages !== null &&
            res.data.Messages.length > 0
          ) {
            setMsg(res.data.Messages);
            setOpen(true);
          } else {
            LoadData();
            toggleModal();
          }
        })
        .catch((err) => {
          console.log('err', err);
        });
    } else {
      const formmatedData = {
        ...quickReplyData,
      };
      AxiosAPI({
        method: 'post',
        url: `${postAPI_Create_QuickReply}`,
        data: formmatedData,
      })
        .then((res) => {
          if (
            res.data.HttpStatusCode !== undefined &&
            res.data.HttpStatusCode === 400 &&
            res.data.Messages !== undefined &&
            res.data.Messages !== null &&
            res.data.Messages.length > 0
          ) {
            setMsg(res.data.Messages);
            setOpen(true);
          } else {
            LoadData();
            toggleModal();
          }
        })
        .catch((err) => {
          console.log('err', err);
        });
    }
  };

  return (
    <Fragment>
      <Modal
        isOpen={visible}
        toggle={toggleModal}
        wrapClassName="modal-right"
        backdrop="static"
      >
        <ModalHeader toggle={toggleModal}>{formLabel}</ModalHeader>
        {quickReplyData != undefined && (
          <ModalBody>
            {/* <pre>{JSON.stringify(serviceData, null, 2)}</pre> */}
            <Label className="mt-3">Name</Label>
            <Input className='input_sty'
              type="text"
              onChange={handleChangeArr}
              value={quickReplyData.name[0].statement}
              name="name"
              maxLength={50}
            />

            <Label className="mt-3">Channel</Label>
            <CustomInput
              type="radio"
              id="exCustomChat"
              name="customChat"
              label="Chat"
              checked={quickReplyData?.templateChannel === 'Chat'}
              onChange={(event) =>
                setQuickReplyData({
                  ...quickReplyData,
                  templateChannel: 'Chat',
                })
              }
            />
            <CustomInput
              type="radio"
              id="exCustomEmail"
              name="customEmail"
              label="Email"
              checked={quickReplyData?.templateChannel === 'Email'}
              onChange={(event) =>
                setQuickReplyData({
                  ...quickReplyData,
                  templateChannel: 'Email',
                })
              }
            />

            {quickReplyData?.templateChannel === 'Email' && (
              <Fragment>
                <Label className="mt-3">Type</Label>
                <CustomInput
                  type="radio"
                  id="exCustomStatic"
                  name="customStatic"
                  label="Static"
                  checked={quickReplyData?.templateType === 'Static'}
                  onChange={(event) =>
                    setQuickReplyData({
                      ...quickReplyData,
                      templateType: 'Static',
                    })
                  }
                />

                <CustomInput
                  type="radio"
                  id="exCustomDynamic"
                  name="customDynamic"
                  label="Dynamic"
                  checked={quickReplyData?.templateType === 'Dynamic'}
                  onChange={(event) =>
                    setQuickReplyData({
                      ...quickReplyData,
                      templateType: 'Dynamic',
                    })
                  }
                />
              </Fragment>
            )}
            {quickReplyData?.templateType === 'Dynamic' &&
              quickReplyData?.templateChannel === 'Email' && (
                <Fragment>
                  <Label className="mt-3">Dynamic Template</Label>

                  {assistantList.length > 0 ? (
                    <Input
                      className="border p-2 mb-3 input_sty"
                      type="select"
                      name="dynamicTemplate"
                      placeholder="Dynamic Conversation Flow"
                      value={quickReplyData?.dynamicTemplate}
                      onChange={handleDynamicTemplate}
                    >
                      <option value="">
                        Select a Dynamic Conversation Flow
                      </option>
                      {assistantList.map((assist, index) => (
                        <option key={index} value={assist.id}>
                          {`${assist.name} (${assist.id})`}
                        </option>
                      ))}
                    </Input>
                  ) : (
                    <Input className='input_sty'
                      type="text"
                      onChange={handleDynamicTemplate}
                      value={quickReplyData?.dynamicTemplate}
                      name="dynamicTemplate"
                      placeholder="Dynamic Conversation Flow"
                    />
                  )}
                  <Label className="mt-3">Widget</Label>
                  <CustomInput
                    type="radio"
                    id="exCustomRatesAndAvailability"
                    name="customRatesAndAvailability"
                    label="Rates & Availability"
                    checked={
                      quickReplyData?.templateWidget === 'RatesAndAvailability'
                    }
                    onChange={(event) =>
                      setQuickReplyData({
                        ...quickReplyData,
                        templateWidget: 'RatesAndAvailability',
                      })
                    }
                  />

                  <CustomInput
                    type="radio"
                    id="exCustomComingSoon"
                    name="customComingSoon"
                    label="Coming Soon"
                    checked={quickReplyData?.templateWidget === 'ComingSoon'}
                    onChange={(event) =>
                      setQuickReplyData({
                        ...quickReplyData,
                        templateWidget: 'ComingSoon',
                      })
                    }
                  />
                </Fragment>
              )}

            <Label className="mt-3">Response Message</Label>
            <Input className='input_sty'
              type="textarea"
              onChange={handleChangeArr}
              value={quickReplyData.message[0].statement}
              name="message"
              rows={10}
            />
          </ModalBody>
        )}
        <ModalFooter>
          <Button color="primary" onClick={handleSubmit}>
            Save
          </Button>
          <Button color="secondary" onClick={toggleModal}>
            Cancel
          </Button>
          {id && (
            <Button color="danger" onClick={toggle}>
              Delete
            </Button>
          )}
        </ModalFooter>
      </Modal>
      {generateDeleteButton()}
      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
    </Fragment>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, domains } = settings;
  return {
    propertyId,
    domains,
  };
};

export default injectIntl(connect(mapStateToProps, {})(AddNewReply));
